// extracted by mini-css-extract-plugin
module.exports = {"wrapperBottom":"footer_wrapperBottom__Dh62T","wrapperTop":"footer_wrapperTop__2GikP","wrapperMedium":"footer_wrapperMedium__27i_x","content":"footer_content__2jt_i"};